import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import api, { ApiInputs, ApiResponses } from 'lib/trpcClient';
import { useState } from 'react';
import { downloadFileFromTrpc } from 'further-ui/utils';

const useFinancialStatementsExcel = () => {
  const [inFlightInvestorExcelDownloads, setInFlightInvestorExcelDownloads] =
    useState<Set<string>>(new Set());

  const { mutateAsync: downloadExcel } =
    api.periodEndReport.downloadFinancialStatementsExcel.useMutation(
      useHandleTrpcMutation<
        ApiResponses['periodEndReport']['downloadFinancialStatementsExcel'],
        ApiInputs['periodEndReport']['downloadFinancialStatementsExcel']
      >()({
        invalidations: [],
        onMutate: ({ investorId }) => {
          setInFlightInvestorExcelDownloads((prev) => {
            const newSet = new Set(prev);
            newSet.add(investorId);
            return newSet;
          });
        },
        onSuccess: (result) => {
          downloadFileFromTrpc(result);
        },
        onSettled: (_, __, input) => {
          setInFlightInvestorExcelDownloads((prev) => {
            const newSet = new Set(prev);
            newSet.delete(input.investorId);
            return newSet;
          });
        },
      }),
    );

  const isDownloadingExcel = (investorId: string) => {
    return inFlightInvestorExcelDownloads.has(investorId);
  };

  return {
    downloadExcel,
    isDownloadingExcel,
  };
};

export default useFinancialStatementsExcel;
